<template>
  <span>
    <v-tooltip v-if="$socket.connected" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon>
          <v-icon color="primary" v-bind="attrs" v-on="on"
            >mdi-check-circle</v-icon
          >
        </v-btn>
      </template>
      <span
        >{{ user.firstName }} {{ user.lastName }} is connected to
        {{ user.eventId }}.</span
      >
    </v-tooltip>
    <v-tooltip bottom v-if="user.role === 'authenticated'">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon>
          <v-icon color="primary" v-bind="attrs" v-on="on">mdi-lock</v-icon>
        </v-btn>
      </template>
      <span>Authenticated for secure voting</span>
    </v-tooltip>
  </span>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      user: (state) => state.user
    })
  }
};
</script>
